import React from "react"
import { Flex, Tag } from "antd"
import { CloseCircleOutlined } from "@ant-design/icons"
import PropTypes from "prop-types"
import styles from "./index.module.css"

/**
 * Reusable filter chips component for displaying and removing selected filters
 */
const FilterChips = ({ selectedItems, options, onRemove }) => {
  if (!selectedItems.length) return null

  return (
    <Flex gap={4} className="mt-s">
      {selectedItems.map((item) => {
        const option = options.find((o) => o.value === item)
        if (!option) return null

        return (
          <Tag
            key={item}
            className={styles.filterChip}
            bordered={true}
            closable
            closeIcon={<CloseCircleOutlined style={{ color: "var(--color-primary)", marginLeft: 8, fontSize: 16 }} />}
            onClose={(e) => {
              e.preventDefault()
              onRemove(item)
            }}
          >
            {option.label}
          </Tag>
        )
      })}
    </Flex>
  )
}

FilterChips.propTypes = {
  selectedItems: PropTypes.array.isRequired,
  options: PropTypes.array.isRequired,
  onRemove: PropTypes.func.isRequired
}

export default React.memo(FilterChips)
